var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents"},[_c('ETopPageText',{attrs:{"maintext":"Support","text":""}}),_c('center',[_vm._v(" Contact us: marek@bardonski.pl ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }